// src/components/chat/ChatToggle.tsx
'use client';

import { motion } from 'framer-motion';
import { MessageCircle, ChevronDown } from 'lucide-react';
import { useChatStore } from '@/store/useChatStore';

export function ChatToggle() {
  const { isOpen, toggleChat } = useChatStore();

  return (
    <motion.button
      onClick={toggleChat}
      className="fixed bottom-12 right-6 bg-[var(--color-primary)] text-white p-4 rounded-full shadow-lg hover:bg-[var(--color-primary-dark)] transition-colors z-[100]"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      aria-label={isOpen ? "Close chat" : "Open chat"}
    >
      {isOpen ? <ChevronDown size={24} /> : <MessageCircle size={24} />}
    </motion.button>
  );
}